import type { UseActionResult, UseMutationProps } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import { gql } from '@apollo/client'
import type { DeleteTaskSubTasksArgs, DeleteTaskSubTasksResult } from '@ztechapps/common.contract'
import { taskDocumentFragment } from './graphql'

export const deleteTaskSubTasksQuery = gql`
  mutation deleteTaskSubTasks($input: DeleteTaskSubTasksArgs!) {
    deleteTaskSubTasks(input: $input) {
      task {
        ...taskDocumentFragment
      }
      subTasks {
        ...taskDocumentFragment
      }
    }
  }
  ${taskDocumentFragment}
`

export const useDeleteTaskSubTasks = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<DeleteTaskSubTasksResult, DeleteTaskSubTasksArgs> => {
  query = query ?? deleteTaskSubTasksQuery

  return useActionMutation({
    query,
    ...props,
  })
}
